// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from "axios";
import router from './router'
import store from './store'
import qs from "qs";
import Vant from "vant";
import { get, post } from '@/request/http';
import 'animate.css'
import 'vant/lib/index.css'
import './utils/rem'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import { Toast } from 'vant'
import { Lazyload } from 'vant' // 导入懒加载模块Lazyload
import './assets/css/base.css';
import './assets/css/style.css';
import './assets/css/css.css';
import 'wowjs/css/libs/animate.css'
import MetaInfo from 'vue-meta-info';
import animated from "animate.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式
Vue.use(animated)
Vue.use(MetaInfo)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$qs = qs
Vue.use(Vant)
Vue.use(Toast)
Vue.use(Lazyload) // 注册懒加载指令
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0);

// });

router.beforeEach((to, from, next) => {
  const backWhiteList = ['wks']
  if (backWhiteList.includes(to.name)) {
    from.meta.keepAlive = true
  } else {
    window.scrollTo(0, 0)
    from.meta.keepAlive = false
  }
  setTimeout(() => {
    next()
  }, 100)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js